import * as React from "react";
import { iNavData, graphData } from "../../../models/models";
import * as ReactRedux from "react-redux";
import { connect } from "react-redux";
import { ACTIONS } from "./../../../controllers/App/actions";
import { IStoreState } from "../../../_reducers";
import { bindActionCreators, Dispatch } from "redux";
import * as _ from "lodash";

export interface NavigationProps {
  className?: string;
  navData: iNavData[];
  data: graphData[];
  currentTab?: string;
  currentSub?: string;
  currentUrl?: string;
  onSetGraph?: any;
  selectedFilter: any;
  onSelectedFilter: (e) => any;
  onSelectedSecondFilter: (e) => any;
  match: any;
}

export interface NavigationState {}

class Navigation extends React.Component<NavigationProps, NavigationState> {
  el: HTMLDivElement;
  constructor(p: NavigationProps) {
    super(p);
  }

  handleSetGraph = currentNav => {
    let graph;

    Object.keys(this.props.data).map(key => {
      if (key === currentNav.key) {
        graph = this.props.data[key];
      }
    });

    this.props.onSetGraph(graph);

    if (graph.firstKey && graph.firstKey.length > 0) {
      this.props.onSelectedFilter(graph.firstKey[0]);

      if (graph.firstKey.length > 1) {
        this.props.onSelectedSecondFilter(graph.firstKey[1]);
      }
    }
  };

  render() {
    let { props, state } = this,
      cls = this.props.className || "";

    return (
      <div className={"navigation " + cls} ref={e => (this.el = e)}>
        <ul className={"navigation__tabs"}>
          {props.navData.map((parent, i) => {
            return (
              <li
                className={
                  parent.key === this.props.currentTab ? "active-tab" : ""
                }
                key={parent.key}
              >
                <a
                  className={
                    parent.key === "tech-giants"
                      ? "navigation__tech-giants"
                      : "navigation__unicorns"
                  }
                  onClick={() =>
                    this.handleSetGraph(
                      _.find(
                        parent.child,
                        child =>
                          child.url ===
                          `/${parent.key}/${this.props.currentSub}`
                      ) || parent.child[0]
                    )
                  }
                  href={
                    window.location.href.split("#")[0] +
                    parent.url +
                    (this.props.currentSub === "ceos"
                      ? "overall"
                      : this.props.currentSub)
                  }
                >
                  {parent.label}
                </a>
                {parent.key === this.props.currentTab && (
                  <ul className="navigation__subs">
                    {parent.child.map(child => {
                      return (
                        <li
                          className={
                            this.props.currentSub === _.kebabCase(child.label)
                              ? "active-sub"
                              : ""
                          }
                          key={child.key}
                        >
                          <a
                            className={
                              parent.key === "tech-giants"
                                ? "navigation__subs--tech-giants"
                                : "navigation__subs--unicorns"
                            }
                            onClick={() => this.handleSetGraph(child)}
                            href={"#" + child.url}
                          >
                            {child.label}
                          </a>
                        </li>
                      );
                    })}
                  </ul>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    );
  }
}

const mapStateToProps = (
  state: IStoreState,
  ownProps
): Partial<NavigationProps> => {
  return {
    navData: state.app.navData,
    data: state.app.data,
    selectedFilter: state.app.selectedFilter
  };
};

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      onSetGraph: ACTIONS.SET_GRAPH,
      onSelectedFilter: ACTIONS.SET_FILTER,
      onSelectedSecondFilter: ACTIONS.SET_SECOND_FILTER
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Navigation);
